import {
  FONT_BACKGROUND_COLOR_CLASS_PREFIX,
  FONT_BACKGROUND_COLORS,
  FONT_COLOR_CLASS_PREFIX,
  FONT_COLORS,
} from "./constants.js";

export function generateCkeCustomColorsCss() {
  const inlineStyles = [];

  FONT_COLORS.forEach(function (colorObj, i) {
    const color = colorObj.color;
    inlineStyles.push(`.${FONT_COLOR_CLASS_PREFIX}${i} { color: ${color}; }`);
  });

  FONT_BACKGROUND_COLORS.forEach(function (colorObj, i) {
    const color = colorObj.color;
    inlineStyles.push(`.${FONT_BACKGROUND_COLOR_CLASS_PREFIX}${i} { background-color: ${color}; }`);
  });

  const style = document.createElement("style");
  style.setAttribute("type", "text/css");
  style.innerHTML = inlineStyles.join("\n");
  document.head.appendChild(style);
}
